import { AddLibraryItemCard } from '@/components/AddLibraryItemCard';
import { uploadAvatarLoadingAtom, useOpenCreateAvatarModal } from '@/pages/avatar';
import { useAnalytics } from '@/services/analytics';
import { MixPanelEvent } from '@/utils/types';
import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

const StyledAddLibraryItemCard = styled(AddLibraryItemCard)`
    width: 100%;
    aspect-ratio: 16/10;
`;

export const CreateAvatarTile = () => {
    const { pathname } = useLocation();

    const mixpanel = useAnalytics();
    const openCreateAvatarModal = useOpenCreateAvatarModal();

    const loading = useRecoilValue<boolean>(uploadAvatarLoadingAtom);

    const handleModalOpen = () => {
        mixpanel?.track('avatar-create-modal', {
            event: MixPanelEvent.CLICK,
            from: 'create-avatar-tile',
        });
        openCreateAvatarModal({
            from: pathname,
        });
    };

    return (
        <StyledAddLibraryItemCard
            id="create-avatar-card"
            testId="avatar-library-create-avatar-card"
            label="Create Avatar"
            onClick={handleModalOpen}
            loading={loading}
        />
    );
};
